import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
  output,
} from '@angular/core';

@Component({
  selector: 'vs-star-rating',
  imports: [],
  templateUrl: './star-rating.html',
  styleUrl: './star-rating.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StarRating {
  readonly starSlots = [1, 2, 3, 4, 5] as const;

  rating = model<number>(0);
  starSize = input<number>(4);
  updatable = input<boolean>(false);

  newRating = output<number>();

  accessibilityLabel(): string {
    return this.updatable()
      ? 'Star rating'
      : `Rated ${this.rating()} out of 5 stars`;
  }

  starOptionLabel(star: number): string {
    return `${star} star${star === 1 ? '' : 's'}`;
  }

  isStarFilled(star: number): boolean {
    return star <= this.rating();
  }

  starDimensionClass(): string {
    const map: Record<number, string> = {
      4: 'size-4',
      5: 'size-5',
      6: 'size-6',
      8: 'size-8',
      10: 'size-10',
      12: 'size-12',
    };
    return map[this.starSize()] ?? 'size-8';
  }

  starSvgClass(star: number): string {
    const dim = this.starDimensionClass();
    const filled = this.isStarFilled(star);
    const base = `${dim} shrink-0 transition-colors duration-200`;
    if (filled) {
      return `${base} text-accent fill-current stroke-current`;
    }
    const hover = this.updatable()
      ? ' hover:text-accent hover:opacity-100'
      : '';
    return `${base} fill-transparent stroke-current text-secondary opacity-90${hover}`;
  }

  updateRating(star: number): void {
    if (!this.updatable()) {
      return;
    }
    this.rating.set(star);
    this.newRating.emit(this.rating());
  }
}
